// TOUR-7 — Post-send CRM handoff (toast link, unsent vs sent history).

import type { FireflyTourArtifact } from "../tourTypes";

export const CRM_HANDOFF_TOUR_ID = "tour-crm-handoff";

export const CRM_HANDOFF_TOUR: FireflyTourArtifact = {
  id: CRM_HANDOFF_TOUR_ID,
  version: 1,
  defaultIntent: "teaching",
  intents: [
    "crm handoff tour",
    "crm link tour",
    "what happens after i send",
    "what happens after i send a lead",
    "after i send a lead",
    "how do i get to my crm",
    "open lead in ghl",
    "open lead in crm",
    "find sent leads",
    "where did my lead go",
    "lead sent what next",
  ],
  bucketRelevance: ["sales"],
  requiredRoles: ["sales"],
  steps: [
    {
      id: "capture-prerequisite",
      target: { mode: "leads", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Already captured?",
        body: "This tour starts after you have a lead on the card. If you have not captured yet, Ask Firefly for the lead capture tour first — then come back here to send and open CRM.",
      },
      advanceOn: "next_button",
    },
    {
      id: "activity-dock",
      target: { mode: "leads", anchorId: "activity-dock-tab", scrollIntoView: true },
      copy: {
        title: "Your Firefly tab",
        body: "Unsent queue and sent history live inside Firefly. Expand it anytime to see what still needs to go out and what you already submitted.",
      },
      advanceOn: "next_button",
    },
    {
      id: "send-lead",
      target: { mode: "leads", anchorId: "send-lead", scrollIntoView: true },
      copy: {
        title: "Send to CRM",
        body: "When name and phone validate, Send to CRM pushes the lead to GoHighLevel. The button turns gray once the handoff succeeds.",
      },
      destructive: true,
    },
    {
      id: "crm-link",
      target: { mode: "leads", anchorId: "lead-crm-link", scrollIntoView: true },
      copy: {
        title: "Open in CRM (lead card)",
        body: "After send, Open in CRM stays on the lead card when your org has a CRM URL in Location Tools. You can jump back to the contact anytime from here.",
      },
      advanceOn: "next_button",
    },
    {
      id: "crm-send-toast",
      target: { mode: "leads", anchorId: "crm-send-toast", scrollIntoView: true },
      copy: {
        title: "Success toast",
        body: "Right after send, a brief success toast also offers Open in CRM — same URL as the card link. It auto-dismisses in a few seconds; the card link is the persistent path.",
      },
      destructive: true,
    },
    {
      id: "unsent-cleanup",
      target: { mode: "leads", anchorId: "unsent-leads-section", scrollIntoView: true },
      copy: {
        title: "Unsent cleanup",
        body: "Still waiting to go out? The Unsent leads section lists every capture not yet in CRM. Use Send all when you are ready to flush the queue in one pass.",
      },
      advanceOn: "next_button",
    },
    {
      id: "send-all-unsent",
      target: { mode: "leads", anchorId: "send-all-unsent", scrollIntoView: true },
      copy: {
        title: "Send all unsent",
        body: "Bulk-send every validated unsent lead from Firefly. Each row still needs name and phone — fix any blocked cards on the lead list first.",
      },
      destructive: true,
    },
    {
      id: "sent-history",
      target: { mode: "leads", anchorId: "sent-leads-section", scrollIntoView: true },
      copy: {
        title: "Sent history",
        body: "Tap Sent · past 30 days to load recent handoffs. Use it to remember who you already sent this month — names and dates only, no re-send from here.",
      },
      advanceOn: "next_button",
    },
    {
      id: "ask-firefly",
      target: { mode: "leads", anchorId: "ask-firefly", scrollIntoView: true },
      copy: {
        title: "Ask Firefly anytime",
        body: "Need capture help instead? Ask Firefly for the lead capture tour — handoff and capture tours are separate paths.",
      },
      advanceOn: "next_button",
    },
  ],
};
